import { render } from "./add_customer_component.vue?vue&type=template&id=ccbe579a&scoped=true"
import script from "./add_customer_component.vue?vue&type=script&lang=js"
export * from "./add_customer_component.vue?vue&type=script&lang=js"

import "./add_customer_component.vue?vue&type=style&index=0&id=ccbe579a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccbe579a"]])

export default __exports__